export default __webpack_public_path__ + "static/media/PrivateAndCookie.ko.c4821613.md";